import ROLES from '@powerednow/shared/constants/roles';
import OAUTH2 from '@powerednow/shared/constants/oauth2';
import TYPES from '@powerednow/shared/constants/payment';
import { BaseDescriptor } from './baseDescriptor';

declare let Ext: any;
declare let L: any;
declare let Deft: any;
export default class AuthTokenExpired extends BaseDescriptor {
    introducedIn = '9.0.0';

    affectedStore = 'AuthConfig';

    name = 'AuthTokenExpired';

    integrationNameMap = {
        3: 'HMRC for MTD',
        4: 'SumUp',
    };

    private generateRules() {
        if (!this.rules.length) {
            const authConfigs = Ext.getStore('AuthConfig').getRecordsByFilterFunc(record => [OAUTH2.TYPES.HMRC, OAUTH2.TYPES.SUMUP].includes(record.get('type')));
            authConfigs.forEach(authConfig => {
                this.rules.push(() => {
                    const isActive = authConfig.get('active');
                    const breakRecord = this.createChangeRecord({
                        type: authConfig.get('type'),
                    });
                    return {
                        created: isActive ? undefined : breakRecord,
                        fixed: isActive ? breakRecord : undefined,
                    };
                });
            });
        }
    }

    async showAlertNotification() {
        const permissionService = Deft.Injector.resolve('permissionService');
        const hasPermission = permissionService.canCurrentUserDo(ROLES.PERMISSIONS.CAN_MANAGE_COMPANY_DATA);
        if (hasPermission) {
            const breakRecords = Ext.getStore('BreakingChange').getRecordsByFilter('originDescriptor', this.name);
            let message = L(
                'AuthTokenExpired.alertMessage',
                `Some of your integration tokens have expired.<br/>
                 No need to worry, this happens from time to time for security reasons, you just have to refresh them.<br/>
                 <br/>
                 <h3>The following tokens are affected:</h3>`,
            );
            const sumupOnlineEnabled = Ext.getStore('PaymentSetting').getRecordForPaymentType(TYPES.TYPES.SUMUP_ONLINE).get('enabled');
            const recordsToProcess = breakRecords.filter(record => record.get('details').type !== 4 || sumupOnlineEnabled);
            if (recordsToProcess.length) {
                const tokenInstructions = recordsToProcess.map(record => {
                    const authType = record.get('details').type;
                    const { promptId, defaultValue } = OAUTH2.CONFIGURE_INSTRUCTIONS[authType];
                    return `<h4><b>${this.integrationNameMap[authType]}</b></h4>
                        <i>How to refresh:</i>  ${L(promptId, defaultValue)}`;
                });
                message += tokenInstructions.join('<hr/>');
                Ext.Msg.showAsync({
                    title: '<h2>Token(s) Expired</h2>',
                    message,
                    buttons: [{
                        text: 'OK',
                        cls: 'button-proceed',
                    }],
                }).then(pressedButton => {
                    if (pressedButton === 'OK') {
                        this.emit('notificationClosed');
                    }
                });
            } else {
                this.emit('notificationClosed');
            }
        } else {
            this.emit('notificationClosed');
        }
    }

    async runCheck(suppressAlert): Promise<void> {
        this.generateRules();
        await super.runCheck(suppressAlert);
    }
}
